export default "__VITE_ASSET__CoA6BAoZ__"